import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  height: 32px;
  width: 217px;
  margin: 0;
  margin-left: auto;
  display: flex;
  ${props => !props.empty && `
    border-bottom: 1px solid ${props.theme.columnChartGridColor};
  `};
`;

const Button = styled.button`
  background-color: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: ${props => props.theme.secondaryColor};
  font: ${props => props.theme.fontWeightBlack} 12px/120% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  padding: 0 16px;
  outline: none;

  &:hover {
    border-bottom: 2px solid ${props => props.theme.secondaryColor};
  }

  ${props => props.active && `
    color: ${props.theme.bodyColor};
    border-bottom: 2px solid ${props.theme.bodyColor};

    &:hover {
      cursor: default;
      border-bottom: 2px solid ${props.theme.bodyColor};
    }
  `};

`;

const GRANULARITIES = {
  m: 'monthly',
  w: 'weekly',
  d: 'daily',
};

export default function GranularityToggle({
  daysAgo, granularity, onChange,
}) {
  const toggle = g => e => {
    e && e.preventDefault();
    (g !== granularity) && onChange(g);
  };

  const isAllTime = !Number.isFinite(daysAgo);
  return (
    <Container empty={!isAllTime}>
      {
        isAllTime
          ? Object.keys(GRANULARITIES).map(g => (
            <Button
              type="button"
              key={g}
              active={g === granularity}
              onClick={toggle(g)}
            >
              {GRANULARITIES[g]}
            </Button>
          ))
          : null
      }
    </Container>
  );
}

GranularityToggle.propTypes = {
  daysAgo: PropTypes.number.isRequired,
  granularity: PropTypes.oneOf(Object.keys(GRANULARITIES)).isRequired,
  onChange: PropTypes.func.isRequired,
};
